import { render, staticRenderFns } from "./Overview2.vue?vue&type=template&id=4e3179c9&scoped=true"
import script from "./Overview2.vue?vue&type=script&lang=js"
export * from "./Overview2.vue?vue&type=script&lang=js"
import style0 from "./Overview2.vue?vue&type=style&index=0&id=4e3179c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3179c9",
  null
  
)

export default component.exports